import ScreenLock from "../../__constants/lock-screen";

const buttonFullpageContent = {
    container : document.querySelector('.btn-menu-container'),
    btnContent : document.querySelector('.btn-menu-content'),
    closeBtn : document.querySelector('.close-btn-content'),
    header: document.querySelector('.header-main'),
    hamburger : document.querySelector('.btn-hamburger'),
    closeContent(){
        buttonFullpageContent.btnContent.classList.remove('is-active');
        buttonFullpageContent.hamburger.classList.remove('is-active');
        ScreenLock.unlock();

        setTimeout( ()=>{
           buttonFullpageContent.btnContent.setAttribute('data-btn', '0');
           buttonFullpageContent.header.classList.remove('increase-index');
        }, 300);
    },

    openContent( el ){
        const dataAttr = el.getAttribute('data-trigger');
        const displayContent = this.btnContent.querySelectorAll(`[data-btn="${dataAttr}"]`);
        this.header.classList.add('increase-index');
        this.hamburger.classList.add('is-active');
        [...displayContent].forEach( (el, ind )=>{
            el.classList.add('active-btn-content')
        });
        this.btnContent.classList.add('is-active');
        this.btnContent.setAttribute('data-btn', `${dataAttr}`);
        ScreenLock.lock();

    },
    init(){
        if( this.container ){
            const buttons = this.container.querySelectorAll('[data-trigger]');
            [...buttons].forEach( (el, ind ) =>{
                el.addEventListener('click', ()=>{
                    this.openContent( el );
                });
            });
        }
    }
}

export default buttonFullpageContent